module.exports = __webpack_public_path__ + "img/userHead.69ddacc2.png";